export default {
  name: 'Modals',
  selector: ['.modal-view', '#modal', '.shout-panel'],
  lazy: true,
  notEditable: true,
  validInnerComponents: [
    'Panel'
  ],
  defaultRules: []
}
